// istanbul ignore file
import {
  Checkbox,
  CircularProgress,
  IconButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem
} from '@mui/material'
import MoreVertIcon from '@mui/icons-material/MoreVert'
import React, { useState, useEffect } from 'react'
import HomeIcon from '../../../assets/hamburg/HomeIcon.png'
import Bookmark from '../../../assets/hamburg/Bookmark.svg'
import LanguageStrings from '../../../i18n/locales'
import ModelPopup from '../../../components/Modal'
import { useSelector, useDispatch } from 'react-redux'
import { type RootState } from '../../../store'
import { type SaveBookmarkDataState } from '../redux/toggleBookmarkSlice'
import { type SaveBookmarkRequest } from '../services/saveBookmarkService'
import {
  saveBookmarkDataservice,
  getBookmarkListDataservice,
  deleteBookmarkservice
} from '../redux/actionCreator'
import { type ConnectedProps, connect } from 'react-redux'
import { SaveBookmarkObjectUpdateAction } from '../redux/saveBookmarkObjectSlice'
import { useAuth } from 'react-oidc-context'
import './ToggleBookmark.css'
import AuthError from '../../../components/ErrorComponents/AuthError'

const ToggleBookmarkStrings = LanguageStrings().ToggleBookmark

const ToggleBookmark = (props: AllProps): JSX.Element => {
  const dispatch = useDispatch()
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const [enableAddBookmarkModel, setEnableAddBookmarkModel] =
    useState<boolean>(false)
  const [enableAddBookmarkNoteModel, setEnableAddBookmarkNoteModel] =
    useState<boolean>(false)
  const [enableRemoveBookmarkModel, setEnableRemoveBookmarkModel] =
    useState<boolean>(false)
  const [enableSetHomescreenModel, setEnableSetHomescreenModel] =
    useState<boolean>(false)
  const [enableSetHomescreenNoteModel, setEnableSetHomescreenNoteModel] =
    useState<boolean>(false)
  const [enableRemoveHomescreenModel, setEnableRemoveHomescreenModel] =
    useState<boolean>(false)
  const [enableMessage, setEnableMessage] = useState<boolean>(false)

  const saveBookmarkObject = useSelector(
    (state: RootState) => state.saveBookmarkObject.saveBookmarkObject
  )
  const saveBookmarkData = useSelector(
    (state: RootState) => state.SaveBookmarkData.saveBookmarkData
  )
  const getBookmarkData = useSelector(
    (state: RootState) => state.GetBookmarkData.getBookmarkData
  )

  const getBookmark = useSelector(
    (state: RootState) => state.GetBookmarkData
  )

  const saveBookmarkDataMessage = useSelector(
    (state: RootState) => state.SaveBookmarkData
  )
  const [enableBookmarkCheckbox, setEnableBookmarkCheckbox] =
    useState<boolean>()
  const [enableHomeScreenCheckbox, setEnableHomeScreenCheckbox] =
    useState<boolean>()

  const auth = useAuth()

  const open = Boolean(anchorEl)

  const handleClick = (event: React.MouseEvent<HTMLElement>): void => {
    setAnchorEl(event.currentTarget)
  }
  const handleClose = (): void => {
    setAnchorEl(null)
  }

  useEffect(() => {
    const bookmarkList =
      getBookmarkData?.filter(
        (e) =>
          (e?.dashboardId === props.deviceId ||
          (props.deviceId == null && e?.dashboardId === props.assetId)) &&
            e?.bookmarkType === 'BOOKMARK'
      ) ?? []
    const homeScreenList =
      getBookmarkData?.filter(
        (e) =>
          (e?.dashboardId === props.deviceId ||
            (props.deviceId == null && e?.dashboardId === props.assetId)) &&
          e?.bookmarkType === 'HOMESCREEN'
      ) ?? []
    setEnableBookmarkCheckbox(bookmarkList?.length > 0)
    setEnableHomeScreenCheckbox(homeScreenList?.length > 0)
    dispatch(SaveBookmarkObjectUpdateAction(undefined))
  }, [props, saveBookmarkData, getBookmarkData])

  const validateAddBookmark = (): void => {
    const filterBookmarks = (getBookmarkData ?? [])?.filter(
      (e) => e?.bookmarkType === 'BOOKMARK'
    )

    if (
      filterBookmarks?.filter(
        (e) =>
          e?.dashboardId === props.deviceId ||
          (props.deviceId == null && e?.dashboardId === props.assetId)
      )?.length > 0
    ) {
      setEnableRemoveBookmarkModel(true)
    } else if (filterBookmarks.length >= 5) {
      setEnableAddBookmarkNoteModel(true)
    } else {
      setEnableAddBookmarkModel(true)
    }
  }

  const validateSetHomescreen = (): void => {
    const filterHomeScreens = (getBookmarkData ?? [])?.filter(
      (e) => e?.bookmarkType === 'HOMESCREEN'
    )
    if (
      filterHomeScreens?.filter(
        (e) =>
          e?.dashboardId === props.deviceId ||
          (props.deviceId == null && e?.dashboardId === props.assetId)
      )?.length > 0
    ) {
      setEnableRemoveHomescreenModel(true)
    } else if (filterHomeScreens.length >= 1) {
      setEnableSetHomescreenNoteModel(true)
    } else {
      setEnableSetHomescreenModel(true)
    }
  }
  const handleSaveBookmark = (
    type: string,
    isBookmark: boolean
  ): void => {
    if (saveBookmarkObject !== null) {
      if (type === 'add') {
        const obj = { ...saveBookmarkObject }
        obj.bookmarkType = isBookmark ? 'BOOKMARK' : 'HOMESCREEN'
        obj.dashboardId = props.deviceId ?? props.assetId
        obj.dashboardType = props.deviceId != null && props.deviceId !== '' ? 'DEVICE' : 'ASSET'
        props.saveBookmarkDataservice(auth.user?.profile.sub ?? '', obj)
      } else if (type === 'remove') {
        const deleteItem = (getBookmarkData ?? []).filter(
          (e) =>
            (e?.dashboardId === props.deviceId ||
              (props.deviceId == null && e?.dashboardId === props.assetId)) &&
            e.bookmarkType === (isBookmark ? 'BOOKMARK' : 'HOMESCREEN')
        )
        props.deleteBookmarkService(
          auth.user?.profile.sub ?? '',
          deleteItem?.[0]?.bookmarkId ?? ''
        )
      }
      setEnableMessage(true)
    }
  }
  return (
    <>
      <IconButton
        aria-haspopup='true'
        aria-controls={open ? 'fade-menu' : undefined}
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
        id ='toggleBookmarkButton'
        style={{ backgroundColor: '#353535', borderRadius: '0px' }}
      >
        <MoreVertIcon />
      </IconButton>
      <Menu
        id='fade-menu'
        MenuListProps={{ 'aria-labelledby': 'fade-button' }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        <MenuItem
          className='menu-bookmark-item'
          disabled={getBookmark.isLoading}
          onClick={() => {
            setAnchorEl(null)
            validateAddBookmark()
          }}
          data-testid="menuItemBookmark"
        >
          <ListItemIcon>
            <Checkbox
            id="checkBoxBookmark"
              checked={enableBookmarkCheckbox}
              color='primary'
              sx={{
                '& .MuiSvgIcon-root': {
                  color: enableBookmarkCheckbox ?? false ? 'primary.main' : '#505050'
                }
              }}
            />
          </ListItemIcon>
          <ListItemText className='item-text' >
            <img
              className='item-icon'
              src={Bookmark}
              style={{ width: '20px', height: '20px' }}
            />
            {ToggleBookmarkStrings.Add_Bookmarks}
          </ListItemText>
        </MenuItem>
        <MenuItem
          disabled={getBookmark.isLoading}
          className='menu-bookmark-item'
          onClick={() => {
            setAnchorEl(null)
            validateSetHomescreen()
          }}
          data-testid="menuItemHomeScreen"
        >
          <ListItemIcon>
            <Checkbox
              checked={enableHomeScreenCheckbox}
              color='primary'
              sx={{
                '& .MuiSvgIcon-root': {
                  color: enableHomeScreenCheckbox === true ? 'primary.main' : '#505050'
                }
              }}
            />
          </ListItemIcon>
          <ListItemText className='item-text'>
            <img
              src={HomeIcon}
              className='item-icon'
              style={{ width: '20px', height: '20px' }}
            />
            {ToggleBookmarkStrings.Set_As_Home_Screen}
          </ListItemText>
        </MenuItem>
      </Menu>

      {enableAddBookmarkModel && (
        <ModelPopup
          buttonTypeNegative='hollow'
          buttonTypePositive='filled'
          title={'Add Bookmark'}
          LabelNegative={'Cancel'}
          LabelPositive={'Add'}
          onClickPositive={() => {
            handleSaveBookmark('add', true)
          }}
          onClickNegative={() => {
            setEnableAddBookmarkModel(false)
          }}
          onClose={() => {
            setEnableAddBookmarkModel(false)
          }}
        >
          <p data-testid="enableAddBookmarkModel" style={{ paddingTop: '1.2em' }}>{ToggleBookmarkStrings.Add_Bookmark_Info}</p>
        </ModelPopup>
      )}
      {enableAddBookmarkNoteModel && (
        <ModelPopup
          buttonTypePositive='filled'
          title={'Note'}
          LabelPositive={'Close'}
          onClickPositive={() => {
            setEnableAddBookmarkNoteModel(false)
          }}
          onClose={() => {
            setEnableAddBookmarkNoteModel(false)
          }}
        >
          <p style={{ paddingTop: '1.2em' }}>
            {ToggleBookmarkStrings?.Bookmark_Note}
          </p>
        </ModelPopup>
      )}
      {enableRemoveBookmarkModel && (
        <ModelPopup
          buttonTypeNegative='hollow'
          buttonTypePositive='filled'
          title={'Remove Bookmark'}
          LabelNegative={'Cancel'}
          LabelPositive={'Remove'}
          onClickPositive={() => {
            handleSaveBookmark('remove', true)
          }}
          onClickNegative={() => {
            setEnableRemoveBookmarkModel(false)
          }}
          onClose={() => {
            setEnableRemoveBookmarkModel(false)
          }}
        >
          <p style={{ paddingTop: '1.2em' }}>
            {ToggleBookmarkStrings.RemoveBookmarkInfo}
          </p>
        </ModelPopup>
      )}

      {enableSetHomescreenModel && (
        <ModelPopup
          buttonTypeNegative='hollow'
          buttonTypePositive='filled'
          title={'Set Homescreen'}
          LabelNegative={'Cancel'}
          LabelPositive={'Set'}
          onClickPositive={() => {
            handleSaveBookmark('add', false)
          }}
          onClickNegative={() => {
            setEnableSetHomescreenModel(false)
          }}
          onClose={() => {
            setEnableSetHomescreenModel(false)
          }}
        >
          <p style={{ paddingTop: '1.2em' }}>
            {ToggleBookmarkStrings.Add_HomeScreen_Info}
            </p>
        </ModelPopup>
      )}

      {enableSetHomescreenNoteModel && (
        <ModelPopup
          buttonTypeNegative='hollow'
          buttonTypePositive='filled'
          title={'Set Homescreen'}
          LabelNegative={'Cancel'}
          LabelPositive={'Set'}
          onClickPositive={() => {
            handleSaveBookmark('add', false)
          }}
          onClickNegative={() => {
            setEnableSetHomescreenNoteModel(false)
          }}
          onClose={() => {
            setEnableSetHomescreenNoteModel(false)
          }}
        >
          <p style={{ paddingTop: '1.2em' }}>
            {ToggleBookmarkStrings.HomeScreen_Note}
          </p>
        </ModelPopup>
      )}

      {enableRemoveHomescreenModel && (
        <ModelPopup
          buttonTypeNegative='hollow'
          buttonTypePositive='filled'
          title={'Remove Homescreen'}
          LabelNegative={'Cancel'}
          LabelPositive={'Remove'}
          onClickPositive={() => { handleSaveBookmark('remove', false) }}
          onClickNegative={() => {
            setEnableRemoveHomescreenModel(false)
          }}
          onClose={() => {
            setEnableRemoveHomescreenModel(false)
          }}
        >
          <p style={{ paddingTop: '1.2em' }}>
            {ToggleBookmarkStrings.Remove_HomeScreenInfo}
          </p>
        </ModelPopup>
      )}

      { // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
        saveBookmarkDataMessage?.isLoading
          ? (
        <ModelPopup title='Loading...'>
          <div
            style={{ display: 'flex', justifyContent: 'center' }}
            className='CircularprogressAmi'
            data-testid= "loader"
          >
            <CircularProgress />
          </div>
        </ModelPopup>
            )
          : (
        <>
          {enableMessage && (
            <ModelPopup
              buttonTypePositive='filled'
              height='auto'
              title={
                [201, 200].includes(saveBookmarkDataMessage?.httpStatus ?? 0)
                  ? `Successfully ${saveBookmarkDataMessage?.httpStatus === 201 ? 'Added' : 'Removed'}`
                  : [403].includes(saveBookmarkDataMessage?.httpStatus ?? 0) ? 'Failed' : `Failed ${saveBookmarkDataMessage?.httpStatus === 201 ? 'Added' : 'Removed'}`
              }
              LabelPositive={'Ok'}
              onClickPositive={() => {
                setEnableMessage(false)
                setEnableAddBookmarkModel(false)
                setEnableRemoveBookmarkModel(false)
                setEnableSetHomescreenModel(false)
                setEnableRemoveHomescreenModel(false)
                setEnableRemoveBookmarkModel(false)
                setEnableSetHomescreenNoteModel(false)
              }}
            >
              <p style={{ paddingTop: '1.2em' }}>
                {saveBookmarkDataMessage?.saveBookmarkData?.message}
                {saveBookmarkDataMessage?.httpStatus === 403 && (<div className='justify-center bookmark-autherror'><AuthError errorMessage="accessForbidden"/></div>)}
              </p>
            </ModelPopup>
          )}
        </>
            )}
    </>
  )
}

interface StateToProps {
  SaveBookmarkData: SaveBookmarkDataState
}

const mapStateToProps = (state: RootState): StateToProps => ({
  SaveBookmarkData: state.SaveBookmarkData
})
interface DispatchToProps {
  saveBookmarkDataservice: (
    subId: string,
    requestParameter: SaveBookmarkRequest
  ) => void
  getBookmarkListDataService: (subId: string) => void
  deleteBookmarkService: (subId: string, dashboardId: string) => void
}

const mapDispatchToProps = (dispatch: any): DispatchToProps => ({
  saveBookmarkDataservice: (
    subId: string,
    requestParameter: SaveBookmarkRequest
  ) => dispatch(saveBookmarkDataservice(subId, requestParameter)),
  getBookmarkListDataService: (subId: string) =>
    dispatch(getBookmarkListDataservice(subId)),
  deleteBookmarkService: (subId: string, dashboardId: string) =>
    dispatch(deleteBookmarkservice(subId, dashboardId))
})

const connector = connect(mapStateToProps, mapDispatchToProps)

interface IBookmarkProps {
  siteId: string | null
  assetId: string | null
  deviceId: string | null
  parentId: string | null
}

type PropsFromRedux = ConnectedProps<typeof connector>
type AllProps = PropsFromRedux & IBookmarkProps

export const MemorizedBookmark = React.memo(connector(ToggleBookmark))
